import { render, staticRenderFns } from "./ModalHistoricoContato.vue?vue&type=template&id=1f570c56&scoped=true"
import script from "./ModalHistoricoContato.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoContato.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoContato.vue?vue&type=style&index=0&id=1f570c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f570c56",
  null
  
)

export default component.exports